
export default {
  props: {
    config: {
      type: Object,
      required: true,
    },
    players: {
      type: Array,
      default: () => [],
    },
    teams: {
      type: Array,
      default: () => [],
    },
    teamOnly: {
      type: Boolean,
      default: false,
    },
    pagePlayer: {
      type: Object,
      default: () => null,
    },
    slotId: {
      type: Number,
      required: true,
    },
    stats: {
      type: Array,
      default: () => [],
    },
  },
  data () {
    return {
      player: null,
      selectedPlayerId: null,
      selectedTeamId: null,
      staticPlayer: false,
      statsLoaded: false,
    };
  },
  inject: [`team`, `season`],
  computed: {
    playerTeam () {
      if (this.player) {
        const team = this.player?.playerSquads[0]?.squad.team;
        return {
          logo: team.images.length ? team.images[0].url : null,
          name: team.teamNames.length ? team.teamNames[0].displayName : null,
        };
      }
      return null;
    },
    position () {
      return this.player?.playerSquads[0]?.position;
    },
    number () {
      return this.player?.playerSquads[0]?.squadNumber;
    },
    age () {
      if (this.player) {
        const now = this.$dayjs();
        return now.diff(this.player.dateOfBirth, `year`);
      }
      return null;
    },
    nationality () {
      if (this.player) {
        return this.player.country?.name;
      }
      return null;
    },
    height () {
      if (this.player && this.player.height > 0) {
        return `${this.player.height}cm`;
      }
      return null;
    },
  },
  watch: {
    selectedTeamId (value) {
      if (value) {
        this.$parent.selectedTeamIds[this.slotId] = value;
        if (!this.staticPlayer) {
          this.selectedPlayerId = null;
        }
        this.$parent.getPlayers(value);
      }
    },
    selectedPlayerId (value) {
      if (value) {
        this.getPlayerStats(this.slotId);
      }
    },
    stats (value) {
      // Load static player on page load if data wasn't available first time
      if (value && this.staticPlayer && !this.statsLoaded) {
        this.getPlayerStats(this.slotId);
      }
    },
    player (value) {
      if (value?.playerSquads.length) {
        this.$set(this.$parent.selectedPlayerPositions, this.slotId, value.playerSquads[0].position);
      } else {
        this.$set(this.$parent.selectedPlayerPositions, this.slotId, null);
      }
    },
  },
  mounted () {
    this.$nextTick(() => {
      if (this.config.slot_type === `player_page` && this.pagePlayer) {
        this.selectedPlayerId = this.pagePlayer.id;
        this.staticPlayer = true;
        this.selectedTeamId = this.team.id;
        this.getPlayerStats(this.slotId);
      }

      if (this.config.slot_type === `manual` && this.config.player.player.length) {
        this.selectedPlayerId = this.config.player.player[0].id;
        this.staticPlayer = true;
        this.selectedTeamId = this.team.id;
        this.getPlayerStats(this.slotId);
      }

      if (this.teamOnly) {
        this.selectedTeamId = this.team.id;
      }
    });
  },
  methods: {
    removePlayer () {
      this.player = null;
      this.selectedPlayerId = null;
      this.$set(this.$parent.playerStats, this.slotId, {});
    },
    async getPlayerStats (slotId) {
      if (this.$parent.playerStats === null) {
        this.$parent.playerStats = {};
      }
      this.player = null;
      const requestUrl = `season/${this.season.id}/player/${this.selectedPlayerId}/team/${this.selectedTeamId}`;
      const params = {
        stat_types: this.stats.join(`||`),
      };

      const request = await this.$getCustomStats(requestUrl, params);

      if (request !== null) {
        this.player = request.entity;
        this.$set(this.$parent.playerStats, slotId, request.entity_stats);

        if (Object.keys(request.entity_stats).length) {
          this.statsLoaded = true;
        }
      }
    },
  },
};
